module.exports = __webpack_public_path__ + "static/media/motor_img.d21e3103.png";